import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export interface ContadoresSidebar {
  /** NFs aguardando validação do RH. */
  notas: number;
  /** Holerites divergentes + linhas de planilha sem colaborador da folha em rascunho. */
  folha: number;
  /** Cadastros incompletos. */
  usuarios: number;
}

// O AppLayout é montado por página: guarda em memória e só busca de novo
// depois de um minuto (ou quando uma tela avisa que algo mudou).
const VALIDADE_MS = 60_000;
let cache: { valor: ContadoresSidebar; em: number } | null = null;
let pendente: Promise<void> | null = null;
const ouvintes = new Set<(c: ContadoresSidebar) => void>();

function buscar() {
  pendente ??= api
    .get<ContadoresSidebar>("/dashboard/rh/contadores")
    .then((valor) => {
      cache = { valor, em: Date.now() };
      ouvintes.forEach((f) => f(valor));
    })
    .catch(() => {
      // Sem contadores a sidebar só não mostra as pílulas.
    })
    .finally(() => {
      pendente = null;
    });
  return pendente;
}

/** Depois de aprovar NF, resolver pendência etc.: recarrega os contadores. */
export function atualizarContadoresSidebar() {
  cache = null;
  void buscar();
}

/** Contadores das pílulas da sidebar. Só o RH busca; os demais recebem null. */
export function useContadoresSidebar(ativo: boolean): ContadoresSidebar | null {
  const [contadores, setContadores] = useState<ContadoresSidebar | null>(cache?.valor ?? null);
  useEffect(() => {
    if (!ativo) return;
    ouvintes.add(setContadores);
    if (!cache || Date.now() - cache.em > VALIDADE_MS) void buscar();
    return () => {
      ouvintes.delete(setContadores);
    };
  }, [ativo]);
  return ativo ? contadores : null;
}
